import React from 'react';
import { Row, Col } from 'reactstrap';
import { Apify } from '../Apify';
import { current_site_id } from '../Site';

const InspirationCards = ({ inspirations }) => {
	return (
		<Row className="px-0 text-center">
			<Col xs="12"className="pb-3">
				<h2>Bliv inspireret og udvid din viden med Aktiedysten</h2>
			</Col>
			<Col xs="12" md="4" className="pb-3 pb-md-0">
				<div className="p-0 inspiration_card">
					<a href={inspirations[0]['link']}>
						<img className="w-100" alt="Inspiration 1" src={inspirations[0]['img@2x']} />
					</a>
				</div>
			</Col>
			<Col xs="12" md="4" className="pb-3 pb-md-0">
				<div className="p-0 inspiration_card">
					<a href={inspirations[1]['link']}>
						<img className="w-100" alt="Inspiration 1" src={inspirations[1]['img@2x']} />
					</a>
				</div>
			</Col>
			<Col xs="12" md="4">
				<div className="p-0 inspiration_card">
					<a href={inspirations[2]['link']}>
						<img className="w-100" alt="Inspiration 1" src={inspirations[2]['img@2x']} />
					</a>
				</div>
			</Col>
		</Row>
	);
}

export default Apify("/z/webpage_elements?site="+current_site_id)
	.with_response_prop("elems")
.wrap((props) => {
	if(!props.elems.inspirations || props.elems.inspirations.length < 3) return null;
	return <InspirationCards inspirations={props.elems.inspirations} />;
});



// WEBPACK FOOTER //
// ./src/c/Inspiration.js